import { render } from "./SearchNavigation.vue?vue&type=template&id=6da36d5b&scoped=true"
import script from "./SearchNavigation.vue?vue&type=script&lang=js"
export * from "./SearchNavigation.vue?vue&type=script&lang=js"

import "./SearchNavigation.vue?vue&type=style&index=0&id=6da36d5b&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da36d5b"]])

export default __exports__